<mos-modal #modal>
	<!-- Condition exists to trigger animations -->
	@if (modal.shouldDisplayContent()) {
	<div class="container" [mosLeaveSync]="'container-out'">
		<mos-header i18n="@@event.valentines-day.title">Promo Saint Valentin&nbsp;!</mos-header>

		<div class="elise-container">
			<mos-canvas-emitter [config]="emitter1Config" #emitter1 />

			<div class="elise"></div>

			<mos-canvas-emitter [config]="emitter2Config" #emitter2 />
		</div>

		<div class="offers">
			@for (offer of offers(); track offer.id) {
			<mos-offer [offer]="offer" [limitedOffer]="true" />
			}
		</div>

		<div class="button-container">
			<a
				role="button"
				tabindex="0"
				(click)="leave()"
				(keydown.enter)="leave()"
				(keydown.space)="leave(); $event.preventDefault()"
			>
				<span i18n="@@common.no-thanks">Non, merci !</span>
			</a>
		</div>
	</div>
	}
</mos-modal>
